<script setup lang="ts">
import { Button } from 'primevue'
import { type Router, useRouter } from 'vue-router'
import { ROUTES } from '@/constants'

const router: Router = useRouter()
</script>

<template>
    <div class="mx-auto flex flex-col items-center justify-center py-20">
        <h1 class="mb-5 text-2xl font-bold">Такой страницы не существует</h1>
        <Button
            class="bg-base-green text-white"
            label="На главную"
            @click="router.push({ name: ROUTES.HOME })" />
    </div>
</template>
